<template>
	<form id="formFile">
		<input @change="upFile" type="file" name="fileName" class="custom-file-input" value="啊啊啊啊"  id="fileName" />
		<label style="display:inline;" class="custom-file-label" for="fileName">选择文件</label>
	</form>
</template>

<script>
	export default {
		 methods: {
			upFile(e) {
				let $target = e.target || e.srcElement
				let file = $target.files[0]
				//alert(file.size)
				//return;
				var reader = new FileReader()
				reader.onload = (data) => {
					let res = data.target || data.srcElement
					this.editImg = res.result
				}
				reader.readAsDataURL(file)
				this.editFiles = file
				let formData = new FormData()
				formData.append('fileName', this.editFiles)
				this.$admin.postAPI(
					`default/upload/?`,
					formData).then(res => {
					let data = res.data;
					console.log(data);
					this.$emit('upFile', data.url);
					this.$Message.success("上传成功！")
				});
			}
		 },
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tool/upload/upload.vue